module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "repairModeManage"
    }
  }, [_c('el-col', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "label-width": "100px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px",
      "width": "150px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择品牌"
    },
    on: {
      "change": _vm.selectBrand
    },
    model: {
      value: (_vm.defaultBrandId),
      callback: function($$v) {
        _vm.defaultBrandId = $$v
      },
      expression: "defaultBrandId"
    }
  }, _vm._l((_vm.brandLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.brandName,
        "value": item.brandId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px",
      "width": "150px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择品类"
    },
    on: {
      "change": _vm.selectCategory
    },
    model: {
      value: (_vm.defaultCategoryId),
      callback: function($$v) {
        _vm.defaultCategoryId = $$v
      },
      expression: "defaultCategoryId"
    }
  }, _vm._l((_vm.categoryLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.categoryName,
        "value": item.categoryId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px",
      "width": "180px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择型号"
    },
    on: {
      "change": _vm.selectModel
    },
    model: {
      value: (_vm.defaultModelId),
      callback: function($$v) {
        _vm.defaultModelId = $$v
      },
      expression: "defaultModelId"
    }
  }, _vm._l((_vm.modelLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.modelName,
        "value": item.modelId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px",
      "width": "150px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择故障大类"
    },
    on: {
      "change": _vm.selectFaultClassId
    },
    model: {
      value: (_vm.defaultFaultClassId),
      callback: function($$v) {
        _vm.defaultFaultClassId = $$v
      },
      expression: "defaultFaultClassId"
    }
  }, _vm._l((_vm.faultClassLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.faultTypesName,
        "value": item.faultTypesId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px",
      "width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "状态"
    },
    model: {
      value: (_vm.statusList.state),
      callback: function($$v) {
        _vm.$set(_vm.statusList, "state", $$v)
      },
      expression: "statusList.state"
    }
  }, _vm._l((_vm.statusList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px",
      "width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "渠道类型"
    },
    model: {
      value: (_vm.officialAccessoriesList.state),
      callback: function($$v) {
        _vm.$set(_vm.officialAccessoriesList, "state", $$v)
      },
      expression: "officialAccessoriesList.state"
    }
  }, _vm._l((_vm.officialAccessoriesList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "160px",
      "margin-bottom": "15px"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "SKU搜索"
    },
    model: {
      value: (_vm.searchSkuNo),
      callback: function($$v) {
        _vm.searchSkuNo = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "searchSkuNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "60px",
      "color": "#169BD5"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.clearFrom()
      }
    }
  }, [_vm._v("重置")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fr",
    staticStyle: {
      "text-align": "right"
    }
  }, [(_vm.basicsAuth.exportModelFaultSolution) ? _c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.downLoad.exportExcel('tableId')
      }
    }
  }, [_vm._v("导出当页数据")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-refresh",
    staticStyle: {
      "font-size": "25px",
      "cursor": "pointer",
      "margin-left": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "id": "tableId",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "",
      "align": "center",
      "width": "90",
      "prop": "extendValue",
      "label": "SKU"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "",
      "align": "center",
      "width": "100",
      "prop": "faultTypesName",
      "label": "故障分类"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "160",
      "label": "故障",
      "prop": "faultSubclassName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "200",
      "prop": "solutionName",
      "label": "维修方式"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v("\n            " + _vm._s(scope.row.solutionName) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "price",
      "label": "维修报价"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.price) ? _c('span', [_vm._v(" " + _vm._s(scope.row.price) + "元 ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "officialPrice",
      "label": "官方价格"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.officialPrice) ? _c('span', [_vm._v("\n            " + _vm._s(scope.row.officialPrice) + "元\n          ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "originalPrice",
      "label": "描述"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.originalPrice) ? _c('span', [_vm._v("\n            " + _vm._s(scope.row.originalPrice) + "\n          ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "state",
      "label": "类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.officialAccessories == 2) ? _c('span', [_vm._v("官方部件")]) : (scope.row.officialAccessories == 1) ? _c('span', [_vm._v("非官方部件")]) : (scope.row.officialAccessories == 3) ? _c('span', [_vm._v("爱回收非官方部件")]) : (scope.row.officialAccessories == 4) ? _c('span', [_vm._v("爱回收官方部件")]) : (scope.row.officialAccessories == 5) ? _c('span', [_vm._v("爱回收手艺人")]) : (scope.row.officialAccessories == 7) ? _c('span', [_vm._v("爱回收保险手艺人")]) : (scope.row.officialAccessories == 0) ? _c('span', [_vm._v("金牌手艺人")]) : _c('span', [_vm._v("其他")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "state",
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.state == 1) ? _c('span', [_vm._v("启用")]) : _c('span', [_vm._v("禁用")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "partType",
      "label": "SKU类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.partType == 0) ? _c('span', [_vm._v("官方")]) : (scope.row.partType == 1) ? _c('span', [_vm._v("三方")]) : _c('span', [_vm._v("其他")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "isDiscounts",
      "label": "是否打折"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDiscounts == 1) ? _c('span', [_vm._v("打折")]) : _c('span', [_vm._v("不打折")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "state",
      "label": "渠道类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.partChannel == 1) ? _c('span', [_vm._v("极吼吼")]) : (scope.row.partChannel == 2) ? _c('span', [_vm._v("全服到家")]) : (scope.row.partChannel == 5) ? _c('span', [_vm._v("爱回收手艺人")]) : (scope.row.partChannel == 0) ? _c('span', [_vm._v("金牌手艺人")]) : (scope.row.partChannel == 6) ? _c('span', [_vm._v("全服快修")]) : (scope.row.partChannel == 7) ? _c('span', [_vm._v("爱回收保险手艺人")]) : _c('span', [_vm._v("其他")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "partNameType",
      "label": "部件类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.partNameType == 1) ? _c('span', [_vm._v("电池")]) : (scope.row.partNameType == 2) ? _c('span', [_vm._v("屏幕")]) : _c('span', [_vm._v("其他")])]
      }
    }])
  }), _vm._v(" "), (_vm.basicsAuth.deleteModelFaultSolution) ? _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "120",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.exitBtn(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }], null, false, 3432076914)
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "visible": _vm.dislog,
      "close-on-click-modal": false,
      "width": "700px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislog = $event
      },
      "close": _vm.emptyDialog
    }
  }, [_c('el-form', {
    ref: "exitForm",
    attrs: {
      "model": _vm.exitForm,
      "label-width": "120px",
      "rules": _vm.exitFormRules,
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "故障名称："
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": true
    },
    model: {
      value: (_vm.exitForm.faultTypesName),
      callback: function($$v) {
        _vm.$set(_vm.exitForm, "faultTypesName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "exitForm.faultTypesName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "维修方式："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择维修方式",
      "filter-method": _vm.dataFilter(_vm.exitForm.solutionName, _vm.repairLists)
    },
    on: {
      "change": _vm.getSolution
    },
    model: {
      value: (_vm.exitForm.solutionId),
      callback: function($$v) {
        _vm.$set(_vm.exitForm, "solutionId", $$v)
      },
      expression: "exitForm.solutionId"
    }
  }, _vm._l((_vm.repairLists), function(m, j) {
    return _c('el-option', {
      key: m.solutionId,
      attrs: {
        "label": m.solutionName,
        "value": m.solutionId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择是否为官方部件"
    },
    model: {
      value: (_vm.exitForm.officialAccessories),
      callback: function($$v) {
        _vm.$set(_vm.exitForm, "officialAccessories", $$v)
      },
      expression: "exitForm.officialAccessories"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "官方部件",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "非官方部件",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "金牌手艺人",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "爱回收非官方部件",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "爱回收官方部件",
      "value": "4"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "爱回收手艺人",
      "value": "5"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "爱回收保险手艺人",
      "value": "7"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价格：",
      "prop": "price"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "clearable": "",
      "oninput": "this.value=this.value.replace(/\\D/g,'')",
      "type": "number"
    },
    model: {
      value: (_vm.exitForm.price),
      callback: function($$v) {
        _vm.$set(_vm.exitForm, "price", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "exitForm.price"
    }
  }), _vm._v(" "), _c('span', [_vm._v("(单位：元)")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原价：",
      "prop": "officialPrice"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "clearable": "",
      "oninput": "this.value=this.value.replace(/\\D/g,'')",
      "type": "number"
    },
    model: {
      value: (_vm.exitForm.officialPrice),
      callback: function($$v) {
        _vm.$set(_vm.exitForm, "officialPrice", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "exitForm.officialPrice"
    }
  }), _vm._v(" "), _c('span', [_vm._v("(单位：元)")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "不要超过五个字",
      "clearable": "",
      "type": "text"
    },
    model: {
      value: (_vm.exitForm.originalPrice),
      callback: function($$v) {
        _vm.$set(_vm.exitForm, "originalPrice", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "exitForm.originalPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "SKU类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择SKU类型"
    },
    model: {
      value: (_vm.exitForm.partType),
      callback: function($$v) {
        _vm.$set(_vm.exitForm, "partType", $$v)
      },
      expression: "exitForm.partType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "三方",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "官方",
      "value": "0"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否打折："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择是否根据原价打折"
    },
    model: {
      value: (_vm.exitForm.isDiscounts),
      callback: function($$v) {
        _vm.$set(_vm.exitForm, "isDiscounts", $$v)
      },
      expression: "exitForm.isDiscounts"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "打折",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "不打折",
      "value": "0"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "渠道类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择渠道类型"
    },
    model: {
      value: (_vm.exitForm.partChannel),
      callback: function($$v) {
        _vm.$set(_vm.exitForm, "partChannel", $$v)
      },
      expression: "exitForm.partChannel"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "极吼吼",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "全服到家",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "金牌手艺人",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "爱回收手艺人",
      "value": "5"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "全服快修",
      "value": "6"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "爱回收保险手艺人",
      "value": "7"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "部件类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择部件类型"
    },
    model: {
      value: (_vm.exitForm.partNameType),
      callback: function($$v) {
        _vm.$set(_vm.exitForm, "partNameType", $$v)
      },
      expression: "exitForm.partNameType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "电池",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "屏幕",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "其他",
      "value": "999"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "维修时长："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "maxlength": "4",
      "oninput": "this.value=this.value.replace(/\\D/g,'').replace(/^0{1,}/g,'')",
      "clearable": "",
      "type": "number"
    },
    model: {
      value: (_vm.exitForm.duration),
      callback: function($$v) {
        _vm.$set(_vm.exitForm, "duration", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "exitForm.duration"
    }
  }), _vm._v(" "), _c('span', [_vm._v("(单位：小时)")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "保修时长："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "maxlength": "4",
      "oninput": "this.value=this.value.replace(/\\D/g,'').replace(/^0{1,}/g,'')",
      "clearable": ""
    },
    model: {
      value: (_vm.exitForm.warrantyPeriod),
      callback: function($$v) {
        _vm.$set(_vm.exitForm, "warrantyPeriod", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "exitForm.warrantyPeriod"
    }
  }), _vm._v(" "), _c('span', [_vm._v("(单位：天)")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详情图片："
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "data": _vm.postData,
      "action": "https://up.qiniup.com",
      "show-file-list": false,
      "accept": _vm.acceptImage,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("\n            只能上传jpg/png文件，且不超过5Mb\n          ")])])], 1), _vm._v(" "), (_vm.exitForm.solutionName !== '') ? _c('el-form-item', {
    attrs: {
      "label": "状态："
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: (_vm.exitForm.state),
      callback: function($$v) {
        _vm.$set(_vm.exitForm, "state", $$v)
      },
      expression: "exitForm.state"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "横线："
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: (_vm.exitForm.isShowLine),
      callback: function($$v) {
        _vm.$set(_vm.exitForm, "isShowLine", $$v)
      },
      expression: "exitForm.isShowLine"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "适用服务模式："
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.exitForm.serviceMode),
      callback: function($$v) {
        _vm.$set(_vm.exitForm, "serviceMode", $$v)
      },
      expression: "exitForm.serviceMode"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("到店维修")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("上门维修")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v("邮寄维修")])], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(
    _vm.exitForm.modelFaultSolutionId !== '' &&
    _vm.exitForm.modelFaultSolutionId !== null
  ) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveStateSubmitBtn('exitForm')
      }
    }
  }, [_vm._v("修改")]) : _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveEventFormSubmitBtn('exitForm')
      }
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.emptyDialog
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-05adc9be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/basicSetting/faultRepair.vue
// module id = 1570
// module chunks = 0